import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { forwardRef } from "react";
import { type TypographyProps } from "~/common/mui";
import ProductMMD from "~/domains/product/components/ProductMMD";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const MMDChip = forwardRef<HTMLElement, Props>((props, ref) => {
  const product = useProductContext(props);

  if (!product.marketDesignation) {
    return null;
  }

  return <ProductMMD marketDesignation={product.marketDesignation} />;
});
